exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#gradient[data-v-6200c685]{margin:200px 0 0;padding:0}#gradient #cover-img[data-v-6200c685]{min-width:100%;background-color:#d3d3d3;min-height:80vh;background-image:linear-gradient(0deg,transparent 0,#fff),url(/storage/imgs/tigers/Medium_WW251531.jpg);background-size:cover;background-position:50%}", ""]);

// exports
